import { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { SelectBox } from "components/uikit-adapter/index"

import Filter from 'components/filters'
import DateRange from 'components/date-range'

import Session from 'utils/user-storage'
import Feature from 'components/feature';

import {
  getAllSuppliersService,
  getAllBusinessUnitsService,
  getAllSituationsService,
  getAllWalletsService,
  getAllLabeledFamiliesService,
  getAllScheduleAgreementsService,
} from './filter.service'

import intl from 'react-intl-universal'
import { GeneralSettingParameter } from 'models/generalSetting/generalSetting'
import HourRange from 'components/hour-range'
import { InputMulti } from 'components/input-multi'
import { isPurchaseOrderFlow } from 'utils/validations-general-settings'

class FilterProject extends Component {
  constructor(props) {
    super()

    this.state = {
      rangeInvalidCollection: false,
      rangeInvalidDelivery: false,
      rangeInvalidDeliveryTime: false,

      IdFornecedor: '',
      IdUnidadeNegocio: '',
      Situacao: '',
      IdCarteira: '',
      IdFamiliaRotulada: '',
      SchedulingAgreement: '',
      DataColetaDe: '',
      DataColetaAte: '',
      DataEntregaDe: '',
      DataEntregaAte: '',
      DeliveryTimeFrom: '',
      DeliveryTimeTo: '',
      PoNumber: [],
      LoadComposition:[],
      suppliers: [],
      businessUnits: [],
      situations: [],
      wallets: [],
      labeledFamilies: [],
      scheduleAgreements: [],
    }

    this.user = Session.get()
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.props) !== JSON.stringify(nextProps) ||
      JSON.stringify(this.state) !== JSON.stringify(nextState)
    )
  }

  componentDidMount() {
    this.loadFiltersData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialData !== prevProps.initialData) {
      this.setState({
        initialData: this.props.initialData,
        IdFornecedor: this.props.initialData.IdFornecedor,
        IdUnidadeNegocio: this.props.initialData.IdUnidadeNegocio,
        DataColetaDe: this.props.initialData.DataColetaDe,
        DataColetaAte: this.props.initialData.DataColetaAte,
        DataEntregaDe: this.props.initialData.DataEntregaDe,
        DataEntregaAte: this.props.initialData.DataEntregaAte,
        Situacao: this.props.initialData.Situacao,
        IdCarteira: this.props.initialData.IdCarteira,
        IdFamiliaRotulada: this.props.initialData.IdFamiliaRotulada,
        SchedulingAgreement: this.props.initialData.SchedulingAgreement,
        DeliveryTimeFrom: this.props.initialData.DeliveryTimeFrom,
        DeliveryTimeTo: this.props.initialData.DeliveryTimeTo,
        PoNumber: this.props.initialData.PoNumber,
        LoadComposition: this.props.initialData.LoadComposition
      });
    }
  }

  loadFiltersData = async () => {
    const { isProvider } = this.props;

    if (!isProvider) {
      await this.getAllSuppliers();
    }
    await this.getAllBusinessUnits();
    await this.getAllSituations();
    await this.getAllWallets();
    await this.getAllLabeledFamilies();
    await this.getAllScheduleAgreements();
  }

  getAllSuppliers = async () => {
    try {
      const { useFilterDefault } = this.props

      const data = await getAllSuppliersService(useFilterDefault, this.user.Id);

      this.processSuppliers(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  getAllBusinessUnits = async () => {
    try {
      const data = await getAllBusinessUnitsService(this.user.Id);
      this.processBusinessUnits(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  getAllSituations = async () => {
    try {
      const data = await getAllSituationsService();
      this.processSituations(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  getAllWallets = async () => {
    try {
      const { useFilterDefault } = this.props
      const data = await getAllWalletsService(useFilterDefault, this.user.Id);
      this.processWallets(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  getAllLabeledFamilies = async () => {
    try {
      const { useFilterDefault } = this.props
      const data = await getAllLabeledFamiliesService(useFilterDefault, this.user.Id);
      this.processLabeledFamilies(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  getAllScheduleAgreements = async () => {
    try {
      const data = await getAllScheduleAgreementsService();
      this.processScheduleAgreements(data);
    } catch (error) {
      this.proccessError(error);
    }
  }

  processSuppliers = (data) => {
    this.setState({
      suppliers: data
    })
  }

  processBusinessUnits = (data) => {
    this.setState({
      businessUnits: data
    })
  }

  processSituations = (data) => {
    this.setState({
      situations: data
    })
  }

  processWallets = (data) => {
    this.setState({
      wallets: data
    })
  }

  processLabeledFamilies = (data) => {
    this.setState({
      labeledFamilies: data
    })
  }

  processScheduleAgreements = (data) => {
    this.setState({
      scheduleAgreements: data,
    })
  }

  changeValue = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  handleCloseSearch = () => {
    const params = {
      PoNumber: this.state.PoNumber,
      LoadComposition: this.state.LoadComposition,
      IdFornecedor: this.state.IdFornecedor,
      IdUnidadeNegocio: this.state.IdUnidadeNegocio,
      DataColetaDe: this.state.DataColetaDe,
      DataColetaAte: this.state.DataColetaAte,
      DataEntregaDe: this.state.DataEntregaDe,
      DataEntregaAte: this.state.DataEntregaAte,
      Situacao: this.state.Situacao,
      IdCarteira: this.state.IdCarteira,
      IdFamiliaRotulada: this.state.IdFamiliaRotulada,
      SchedulingAgreement: this.state.SchedulingAgreement,
      DeliveryTimeFrom: this.state.DeliveryTimeFrom,
      DeliveryTimeTo: this.state.DeliveryTimeTo,
    }

    this.props.handleClose(params)
  }

  handleCleanClick = () => {
    const params = {
      PoNumber: [],
      LoadComposition:[],
      IdFornecedor: '',
      IdUnidadeNegocio: '',
      DataColetaDe: '',
      DataColetaAte: '',
      DataEntregaDe: '',
      DataEntregaAte: '',
      Situacao: '',
      IdCarteira: '',
      IdFamiliaRotulada: '',
      SchedulingAgreement: '',
      DeliveryTimeFrom: '',
      DeliveryTimeTo: '',

      rangeInvalidCollection: false,
      rangeInvalidDelivery: false,
      rangeInvalidDeliveryTime: false,
      rangeInvalidUpdate: false
    }

    this.setState(params, () => this.props.handleClose(params))
  }

  proccessError = (err) => {
    console.log(err)
  }

  changeFormInvalido = (inputName, invalido) => {
    this.setState({
      [inputName]: invalido
    })
  }

  isValidRanges = () => {
    const {
      rangeInvalidCollection,
      rangeInvalidDelivery,
      rangeInvalidDeliveryTime,

    } = this.state

    return (rangeInvalidDelivery || rangeInvalidCollection || rangeInvalidDeliveryTime)
  }

  render() {
    const { isProvider, showFilter } = this.props

    const {
      IdFornecedor,
      IdUnidadeNegocio,
      Situacao,
      IdCarteira,
      IdFamiliaRotulada,
      SchedulingAgreement,
      DataColetaDe,
      DataColetaAte,
      DataEntregaDe,
      DataEntregaAte,
      suppliers,
      businessUnits,
      situations,
      wallets,
      labeledFamilies,
      scheduleAgreements,
      DeliveryTimeFrom,
      DeliveryTimeTo,
      PoNumber,
      LoadComposition
    } = this.state

    return (
      <Filter
        showFilter={showFilter}
        handleCleanClick={this.handleCleanClick}
        handleCloseSearch={this.handleCloseSearch}
        disabledSearch={this.isValidRanges()}
      >
        {isPurchaseOrderFlow() &&
          <Row>
            <Col xs={12} lg={12} md={12}>
              <InputMulti
                className='poNumberInputMulti'
                key={PoNumber}
                labelText={intl.get('commons.PoSapCode')}
                onChange={value => this.changeValue('PoNumber', value)}
                value={PoNumber}
               />
            </Col>
          </Row>
        }
        {
          <Row>
            <Col xs={12} lg={12} md={12}>
              <InputMulti
                className='loadCompositionInputMulti'
                key={LoadComposition}
                labelText={intl.get('commons.composition')}
                onChange={value => this.changeValue('LoadComposition', value)}
                value={LoadComposition}
               />
            </Col>
          </Row>
        }
        {!isProvider &&
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                className='origemSelectBox'
                name='origem'
                label={intl.get('commons.source')}
                placeholder={intl.get('commons.source')}
                valueKey='IdFornecedor'
                labelKey='Descricao'
                value={IdFornecedor}
                options={suppliers}
                onChange={value => this.changeValue('IdFornecedor', value === null ? '' : value.IdFornecedor)}
                searchable
                openOnFocus
                clearable
              />
            </Col>
          </Row>
        }
        <Row>
          <Col xs={12} lg={12} md={12}>
            <SelectBox
              className='destinoSelectBox'
              name='center'
              label={intl.get('commons.destiny')}
              placeholder={intl.get('commons.destiny')}
              valueKey='IdUnidadeNegocio'
              labelKey='Descricao'
              value={IdUnidadeNegocio}
              options={businessUnits}
              onChange={value => this.changeValue('IdUnidadeNegocio', value === null ? '' : value.IdUnidadeNegocio)}
              searchable
              openOnFocus
              clearable
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={12} md={12}>
            <SelectBox
              className='situacaoSelectBox'
              name='situacao'
              label={intl.get('commons.situation')}
              placeholder={intl.get('commons.situation')}
              valueKey='Id'
              labelKey='Description'
              value={Situacao}
              options={situations}
              onChange={value => this.changeValue('Situacao', value === null ? '' : value.Id)}
              searchable
              openOnFocus
              clearable
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={12} md={12}>
            <SelectBox
              className='carteiraSelectBox'
              name='carteira'
              label={intl.get('commons.wallet')}
              placeholder={intl.get('commons.wallet')}
              valueKey='Id'
              labelKey='Description'
              value={IdCarteira}
              options={wallets}
              onChange={value => this.changeValue('IdCarteira', value === null ? '' : value.Id)}
              searchable
              openOnFocus
              clearable
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={12} md={12}>
            <SelectBox
              className='familiaRotuladaSelectBox'
              name='familiaRotulada'
              label={intl.get('commons.labeledFamily')}
              placeholder={intl.get('commons.labeledFamily')}
              valueKey='Id'
              labelKey='Description'
              value={IdFamiliaRotulada}
              options={labeledFamilies}
              onChange={value => this.changeValue('IdFamiliaRotulada', value === null ? '' : value.Id)}
              searchable
              openOnFocus
              clearable
            />
          </Col>
        </Row>
        <Feature flags={GeneralSettingParameter.OrderSettings}>
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                className='scheduleAgreementsSelectBox'
                name='scheduleAgreements'
                label={intl.get('commons.schedulingAgreement')}
                placeholder={intl.get('commons.schedulingAgreement')}
                valueKey='SchedulingAgreement'
                labelKey='SchedulingAgreement'
                value={SchedulingAgreement}
                options={scheduleAgreements}
                onChange={value => this.changeValue('SchedulingAgreement', value === null ? '' : value.SchedulingAgreement)}
                searchable
                openOnFocus
                clearable
              />
            </Col>
          </Row>
        </Feature>
        <Row>
          <Col xs={12} lg={12} md={12}>
            <DateRange
              labelDe={intl.get('commons.collectDateDE')}
              labelAte={intl.get('commons.collectDateAT')}
              dataDe={DataColetaDe}
              dataAte={DataColetaAte}
              onChangeDataDe={value => this.changeValue('DataColetaDe', value)}
              onChangeDataAte={value => this.changeValue('DataColetaAte', value)}
              onRangeIsValid={value => this.changeFormInvalido('rangeInvalidCollection', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={12} md={12}>
            <DateRange
              labelDe={intl.get('loadOptimization.filter.deliveryDateOf')}
              labelAte={intl.get('loadOptimization.filter.deliveryDateBy')}
              dataDe={DataEntregaDe}
              dataAte={DataEntregaAte}
              onChangeDataDe={value => this.changeValue('DataEntregaDe', value)}
              onChangeDataAte={value => this.changeValue('DataEntregaAte', value)}
              onRangeIsValid={value => this.changeFormInvalido('rangeInvalidDelivery', value)}
            />
          </Col>
        </Row>
        <HourRange
          className='hourRangeInput'
          labelFrom={intl.get('commons.deliveryTimeFrom')}
          labelTo={intl.get('commons.deliveryTimeTo')}
          hourFrom={DeliveryTimeFrom}
          hourTo={DeliveryTimeTo}
          onChangeDeliveryTimeMin={value => this.changeValue('DeliveryTimeFrom', value)}
          onChangeDeliveryTimeMax={value => this.changeValue('DeliveryTimeTo', value)}
          onRangeIsValid= {value => this.changeFormInvalido('rangeInvalidDeliveryTime', value)}
        />
      </Filter>
    )
  }
}

FilterProject.propTypes = {
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  isProvider: PropTypes.any.isRequired,
  showFilter: PropTypes.bool.isRequired,
  useFilterDefault: PropTypes.any.isRequired
}

FilterProject.defaultProps = {
  initialData: {},
}

export default FilterProject
